<template>
  <div class="about">
    <h1>Test a question here</h1>
    <QuestionEdit />
  </div>
</template>


<script>
import QuestionEdit from '../components/QuestionEdit.vue'

export default {
  name: 'Edit',
  components: {
    QuestionEdit
  },
}
</script>